import { useEffect } from 'react';

const localStorageKey = 'theme';

export const useTheme = () => {
  const selectedTheme = localStorage.getItem(localStorageKey) || 'light';
  useEffect(() => {
    localStorage.setItem(localStorageKey, selectedTheme);

    document.documentElement.setAttribute('data-theme', selectedTheme);
  }, [selectedTheme]);
};
